import { useSeo } from "@/lib/seo";

const SECTIONS = [
  {
    title: "1. What this policy covers",
    body: "This Privacy Policy explains how RentAnything.ai (\"RentAnything,\" \"we,\" \"us\") collects, uses, and shares information when you visit rentanything.ai, contact our sales team, or use our software. By using our website or services you agree to this policy.",
  },
  {
    title: "2. Information we collect",
    body: "We collect information you give us when you fill in a contact or demo form (name, business name, email, phone, rental vertical, fleet size, message). We also automatically collect basic technical information such as IP address, browser type, device type, and page-level analytics. We use cookies and similar technologies for basic analytics and session continuity.",
  },
  {
    title: "3. How we use your information",
    body: "We use your information to respond to your inquiries, schedule demos, deliver our services, send service updates, and improve our product and website. We do not sell your personal information. We may share limited data with service providers (e.g. email and analytics tools) under contract.",
  },
  {
    title: "4. How long we keep your information",
    body: "Lead and contact information is retained as long as you have an active conversation with us, plus a reasonable period thereafter for our records. You can request deletion at any time by emailing inquiry@rentanything.ai.",
  },
  {
    title: "5. Your rights",
    body: "Depending on your jurisdiction, you may have rights to access, correct, or delete the personal information we hold about you, or to withdraw consent. Contact inquiry@rentanything.ai to exercise any of these rights.",
  },
  {
    title: "6. Children's privacy",
    body: "Our services are not directed to children under 16, and we do not knowingly collect personal information from children under 16.",
  },
  {
    title: "7. International transfers",
    body: "We are based in the United States. If you are accessing the site from outside the US, your information may be transferred to and processed in the US.",
  },
  {
    title: "8. Changes to this policy",
    body: "We may update this policy from time to time. The 'last updated' date below reflects the most recent revision.",
  },
  {
    title: "9. Contact",
    body: "Questions about this policy or your information? Email inquiry@rentanything.ai.",
  },
];

export default function Privacy() {
  useSeo({
    title: "Privacy Policy",
    description: "How RentAnything.ai collects, uses, and protects your information.",
    path: "/privacy",
  });
  return (
    <section className="ra-section">
      <div className="ra-container max-w-3xl">
        <header>
          <span className="ra-eyebrow">Legal</span>
          <h1 className="mt-3 ra-h1">Privacy Policy</h1>
          <p className="mt-3 text-sm text-ra-ink/60">Last updated: February 5, 2026</p>
        </header>
        <div className="mt-10 space-y-8 text-[16px] leading-[1.75] text-ra-ink/85">
          {SECTIONS.map((s) => (
            <section key={s.title}>
              <h2 className="font-display text-xl font-semibold text-ra-ink">{s.title}</h2>
              <p className="mt-3">{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </section>
  );
}
